import { Box, Button, Typography } from "@mui/material";
import { PhysicalSummaryTable } from "../../components/DOAAuditReportComponents/PhysicalSummaryTable";
import { SummaryTable } from "../../components/DOAAuditReportComponents/SummaryTable";
import { MainContainer } from "../../components/MainContainerComp";
import { ISummary } from "./CasualAuditReportData";

interface ICasualAuditReportResultsSummaryProps {
  data: ISummary,
  onDetailsButtonClick: () => void
}

export const CasualAuditReportResultsSummary: React.FC<ICasualAuditReportResultsSummaryProps> = ({
  data, onDetailsButtonClick
}) => {
  return (
    <MainContainer sx={{ pb: 6 }} hasGreyBg>
      <Typography 
        className='sub-title' 
        data-automation="selected-shift-lbl"
      >
        {data.selectedDispatchInfo}
      </Typography>
      <Box sx={{ position: "relative" }}>
        <SummaryTable
          tbd={data.tbd}
          totAvRaw={data.totAvRaw}
          eligible={data.eligible}
          notEligible={data.notEligible}
          avForcedIn={data.avForcedIn}
          avAndAVForcedIn={data.avAndAVForcedIn}
          unmatched={data.unmatched}
          summaryMessage={data.summaryMessage}
        />
        <PhysicalSummaryTable
          totalJobs={data.totalJobs}
          filledWithDoaEmployees={data.filledWithDoaEmployees}
          filledWithWalkIn={data.filledWithWalkIn}
          shortages={data.shortages}
        />
        <Button
          variant="fixed-right"
          size="medium"
          onClick={onDetailsButtonClick}
          data-automation="details-btn"
        >
          Details
        </Button>
      </Box>
    </MainContainer>
  )
}